import React, { useState, useEffect } from "react";
import "./AdminController.css";

import { IoMdRefresh } from "react-icons/io";
import { FaClock } from "react-icons/fa6";
import { FaUserGear } from "react-icons/fa6";
import { PiHandDepositFill } from "react-icons/pi";
import { PiDownloadSimpleBold } from "react-icons/pi";
import { MdOutlineAssessment } from "react-icons/md";
import PaymentGateway from "./PaymentGateway";
import { TextBox, TagBox, SelectBox } from "devextreme-react";

import Button from "@mui/material/Button";

import {
  getTradersForUserManagement,
  createUser,
  getUsers,
  createTrader,
  getTradersAdmin,
} from "../store";
import { useDispatch, useSelector } from "react-redux";

import { showNotification } from "../components/NotificationProvider";
import { FaClipboard } from "react-icons/fa";
import { FaSave } from "react-icons/fa";

import BottomNavigation from "@mui/material/BottomNavigation";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";
import { IoPersonAddSharp } from "react-icons/io5";
import { IoIosListBox } from "react-icons/io";
import { RiCustomerServiceFill } from "react-icons/ri";
import { MdCreateNewFolder } from "react-icons/md";
import { FaCreditCard } from "react-icons/fa";
import { MdAccountBalance } from "react-icons/md";
import { MdManageAccounts } from "react-icons/md";
import { MdGroups } from "react-icons/md";

import UserManagementPanel from "../components/UserManagementPanel";
import TraderManagementPanel from "../components/TraderManagementPanel";
import TraderLogsPanel from "../components/TraderLogsPanel";
import CardAccountManagement from "../components/CardAccountManagement";
import TraderKassaManagementView from "./TraderKassaManagementView";
import TeamManagementPanel from "../components/TeamManagementPanel";

const AdminController = () => {
  const dispatch = useDispatch();
  const traders = useSelector(
    (state) => state.trader.tradersForUserManagement || []
  );
  const currentUser = useSelector((state) => state.user.user?.user);
  const [selectedControl, setSelectedControl] = useState("");
  const [userName, setUserName] = useState("");
  const [userLastName, setUserLastName] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [userPassword, setUserPassword] = useState("");
  const [userAuthCode, setUserAuthCode] = useState("");
  const [selectedTraders, setSelectedTraders] = useState([]);
  const [userCard, setUserCard] = useState(null);
  const [traderCard, setTraderCard] = useState(null);
  const [permissions, setPermissions] = useState(["Deposit", "Withdrawal"]);
  const [dropPermission, setDropPermission] = useState("false");

  const [navValue, setNavValue] = useState(0);
  const [traderNavValue, setTraderNavValue] = useState(0);
  const [traderName, setTraderName] = useState("");
  const [traderVersion, setTraderVersion] = useState("");
  const [traderLogsNavValue, setTraderLogsNavValue] = useState(0);

  // C2C Management states
  const [c2cNavValue, setC2cNavValue] = useState(0);

  // Add new state variables for integration form
  const [selectedTraderForIntegration, setSelectedTraderForIntegration] =
    useState("");
  const [callbackUrl, setCallbackUrl] = useState("");
  const [redirectUrl, setRedirectUrl] = useState("");
  const [integrationSaved, setIntegrationSaved] = useState(false);

  // Admin type permission check - ÖNCE admin tipi kontrolü yapılmalı
  const adminType = currentUser?.adminType;
  const isSuperAdmin = adminType === "superadmin";
  const isFullAdmin = adminType === "full" || isSuperAdmin;
  const isC2CAdmin = adminType === "c2c" || isFullAdmin;
  const hasTraderKassaAccess =
    currentUser?.traderKassaManagement?.enabled || false;

  // Get full user state for debug logs (hook must be called unconditionally)
  const fullUserState = useSelector((state) => state.user);

  // Check if logs should be disabled (via REACT_APP_DISABLE_LOGS env variable)
  const shouldLog = process.env.NODE_ENV !== "production" && process.env.REACT_APP_DISABLE_LOGS !== "true";

  // Debug logs - sadece development modda ve REACT_APP_DISABLE_LOGS false ise
  if (shouldLog) {
    console.log("AdminController Debug:");
    console.log("Full user state:", fullUserState);
    console.log("currentUser:", currentUser);
    console.log("adminType:", adminType);
    console.log("isFullAdmin:", isFullAdmin);
    console.log("isC2CAdmin:", isC2CAdmin);
    console.log("hasTraderKassaAccess:", hasTraderKassaAccess);
    console.log("traderKassaManagement:", currentUser?.traderKassaManagement);
  }

  const handleCreateTrader = async () => {
    const traderData = {
      traderName: traderName,
      traderVersion: traderVersion,
    };

    if (!traderName) {
      showNotification("Error", "danger", "Trader Name is required");
      return;
    }

    if (!traderVersion) {
      showNotification("Error", "danger", "Trader version is required");
      return;
    }

    try {
      const response = await dispatch(createTrader(traderData)).unwrap();
      if (process.env.NODE_ENV !== "production" && process.env.REACT_APP_DISABLE_LOGS !== "true") {
        console.log(response.data);
      }
      setTraderCard({
        traderName: response.data.data.trader.traderName,
        traderVersion: response.data.data.trader.traderVersion,
        fileName: `${response.data.data.trader.traderVersion}-${response.data.data.trader.traderName}-API-Documentation.docx`,
        downloadUrl: response.data.data.downloadUrl,
      });
      showNotification("Success", "success", "Trader created successfully");
    } catch (err) {
      if (process.env.NODE_ENV !== "production" && process.env.REACT_APP_DISABLE_LOGS !== "true") {
        console.log(err);
      }
      showNotification("Error", "danger", err);
    }
  };

  const [users, setUsers] = useState([]);

  const fetchUsers = async () => {
    // Önce admin tipi kontrolü yapılmalı
    if (!adminType) {
      return; // Admin tipi yoksa hiçbir şey yapma
    }

    // Sadece superadmin ve full admin tipleri için user verilerini çek
    if (adminType === "superadmin" || adminType === "full") {
      try {
        if (process.env.NODE_ENV !== "production" && process.env.REACT_APP_DISABLE_LOGS !== "true") {
          console.log("Fetching users from backend...");
        }
        const response = await dispatch(getUsers()).unwrap();
        if (process.env.NODE_ENV !== "production" && process.env.REACT_APP_DISABLE_LOGS !== "true") {
          console.log("Backend response:", response);
          console.log("Users data:", response.data.data.users);
        }
        setUsers(response.data.data.users);
      } catch (err) {
        if (process.env.NODE_ENV !== "production" && process.env.REACT_APP_DISABLE_LOGS !== "true") {
          console.error("Error fetching users:", err);
        }
      }
    }
  };

  useEffect(() => {
    fetchUsers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [adminType]);

  const handleCreateUser = async () => {
    setUserCard(null);

    const userData = {
      name: userName,
      lastName: userLastName,
      email: userEmail,
      password: userPassword,
      permissions: permissions,
      dropDepositPermission: dropPermission,
      traders: selectedTraders,
    };

    try {
      const response = await dispatch(createUser(userData)).unwrap();
      if (process.env.NODE_ENV !== "production" && process.env.REACT_APP_DISABLE_LOGS !== "true") {
        console.log(response);
      }
      setUserCard({
        email: userEmail,
        password: userPassword,
        authCode: response.data.googleAuthenticatorCode,
      });
      showNotification("Success", "success", "User created successfully");

      fetchUsers();
    } catch (err) {
      if (process.env.NODE_ENV !== "production" && process.env.REACT_APP_DISABLE_LOGS !== "true") {
        console.log(err);
      }
      showNotification("Error", "danger", err);
    }
  };

  useEffect(() => {
    const fetchTraders = async () => {
      try {
        await dispatch(getTradersForUserManagement()).unwrap();
      } catch (err) {
        if (process.env.NODE_ENV !== "production" && process.env.REACT_APP_DISABLE_LOGS !== "true") {
          console.log(err);
        }
      }
    };

    fetchTraders();
  }, [dispatch]);

  // Set default selected control based on adminType
  useEffect(() => {
    if (currentUser && adminType === "c2c" && !selectedControl) {
      setSelectedControl("c2c-management");
    }
  }, [currentUser, adminType, selectedControl]);

  // Temporary override for testing
  // const adminType = "c2c"; // REMOVE THIS AFTER TESTING
  // const isFullAdmin = adminType === "full";
  // const isC2CAdmin = adminType === "c2c" || isFullAdmin;

  const handleTraderChange = (e) => {
    if (e.value.includes("all")) {
      setSelectedTraders(traders.map((trader) => trader._id));
    } else {
      setSelectedTraders(e.value);
    }
  };

  const handleButtonClick = (control) => {
    setSelectedControl(control);
  };

  const handleCopy = () => {
    const userInfo = `Email: ${userCard.email}\nPassword: ${userCard.password}\nAuthenticator Code: ${userCard.authCode}`;
    navigator.clipboard.writeText(userInfo).then(
      () => {
        showNotification("Copied", "success", "User info copied to clipboard");
      },
      (err) => {
        showNotification("Error", "danger", err);
      }
    );
  };

  // Add new function to handle integration form submission
  const handleSaveIntegration = () => {
    if (!selectedTraderForIntegration || !callbackUrl || !redirectUrl) {
      showNotification("Error", "danger", "Please fill all fields");
      return;
    }

    // Clear form fields
    setSelectedTraderForIntegration("");
    setCallbackUrl("");
    setRedirectUrl("");

    // Show success state
    setIntegrationSaved(true);

    showNotification(
      "Success",
      "success",
      "Integration settings saved successfully"
    );

    // Reset success state after 5 seconds
    setTimeout(() => {
      setIntegrationSaved(false);
    }, 5000);
  };

  return (
    <div className="admin-controller">
      <div className="deposit-body">
        <div className="deposit-header-container">
          <div className="deposit-header">
            <FaClock className="deposit-header-icon" />
            <span>Admin Controller </span>
          </div>

          <div className="deposit-header-refresh">
            <IoMdRefresh className="refresh-icon" />
            <span>Refresh</span>
          </div>
        </div>
        <div className="admin-controller-header">
          {isFullAdmin && (
            <div
              className={
                selectedControl === "user-management"
                  ? "admin-button admin-button-active"
                  : "admin-button"
              }
              onClick={() => handleButtonClick("user-management")}
            >
              <FaUserGear className="admin-button-icon" />
              <span>User Management</span>
            </div>
          )}

          {isFullAdmin && (
            <div
              className={
                selectedControl === "trader-management"
                  ? "admin-button admin-button-active"
                  : "admin-button"
              }
              onClick={() => handleButtonClick("trader-management")}
            >
              <RiCustomerServiceFill className="admin-button-icon" />
              <span>Trader Management</span>
            </div>
          )}

          {isFullAdmin && (
            <div
              className={
                selectedControl === "trader-logs"
                  ? "admin-button admin-button-active"
                  : "admin-button"
              }
              onClick={() => handleButtonClick("trader-logs")}
            >
              <MdOutlineAssessment className="admin-button-icon" />
              <span>Trader Logs</span>
            </div>
          )}

          {isC2CAdmin && (
            <div
              className={
                selectedControl === "c2c-management"
                  ? "admin-button admin-button-active"
                  : "admin-button"
              }
              onClick={() => handleButtonClick("c2c-management")}
            >
              <MdAccountBalance className="admin-button-icon" />
              <span>C2C Management</span>
            </div>
          )}

          {hasTraderKassaAccess && (
            <div
              className={
                selectedControl === "trader-kassa-management"
                  ? "admin-button admin-button-active"
                  : "admin-button"
              }
              onClick={() => handleButtonClick("trader-kassa-management")}
            >
              <MdManageAccounts className="admin-button-icon" />
              <span>Trader Kassa Management</span>
            </div>
          )}

          {isSuperAdmin && (
            <div
              className={
                selectedControl === "team-management"
                  ? "admin-button admin-button-active"
                  : "admin-button"
              }
              onClick={() => handleButtonClick("team-management")}
            >
              <MdGroups className="admin-button-icon" />
              <span>Team Management</span>
            </div>
          )}

          {/* <div
            className={
              selectedControl === "deposit-management"
                ? "admin-button admin-button-active"
                : "admin-button"
            }
            // onClick={() => {
            //   handleButtonClick("deposit-management");
            // }}
          >
            <PiHandDepositFill className="admin-button-icon" />
            <span>Deposit Management</span>
          </div> */}

          {/* <div
            className={
              selectedControl === "withdrawal-management"
                ? "admin-button admin-button-active"
                : "admin-button"
            }
            onClick={() => {}}
          >
            <PiDownloadSimpleBold className="admin-button-icon" />
            <span>Withdrawal Management</span>
          </div> */}
        </div>
        <div className="admin-controller-body">
          {selectedControl === "user-management" && (
            <div className="selected-control-panel">
              <div className="control-panel-header">
                <div>User Management</div>
                <BottomNavigation
                  showLabels
                  value={navValue}
                  onChange={(event, newValue) => {
                    setNavValue(newValue);
                  }}
                  sx={{
                    marginLeft: "2rem",
                    backgroundColor: "#1C273A",
                    height: "80px", // Yüksekliği ayarlama
                    fontSize: "3rem",
                    "& .MuiBottomNavigationAction-root": {
                      color: "#FFFFFF", // Varsayılan metin ve ikon rengi
                    },
                    "& .Mui-selected": {
                      color: "#00E396", // Seçili öğenin rengi
                    },
                  }}
                >
                  <BottomNavigationAction
                    label="Create User"
                    icon={<IoPersonAddSharp />}
                  />
                  <BottomNavigationAction
                    label="User List"
                    icon={<IoIosListBox />}
                  />
                </BottomNavigation>
              </div>

              <div className="control-panel-body">
                {navValue === 0 && (
                  <div className="control-panel-user">
                    {userCard && (
                      <div className="user-card">
                        <div className="button-copy">
                          <Button
                            icon="copy"
                            type="default"
                            onClick={handleCopy}
                          />
                        </div>
                        <div>Email: {userCard.email}</div>
                        <div>Password: {userCard.password}</div>
                        <div>Authenticator Code: {userCard.authCode}</div>
                      </div>
                    )}
                    <div className="profile-input-group-col">
                      <label>Person Name</label>
                      <TextBox
                        className="custom-textbox"
                        value={userName}
                        onValueChanged={(e) => setUserName(e.value)}
                        placeholder="First Name"
                      />
                    </div>

                    <div className="profile-input-group-col">
                      <label>Last Name</label>
                      <TextBox
                        className="custom-textbox"
                        value={userLastName}
                        onValueChanged={(e) => setUserLastName(e.value)}
                        placeholder="Last Name"
                      />
                    </div>
                    <div className="profile-input-group-col">
                      <label>Email</label>
                      <TextBox
                        className="custom-textbox"
                        value={userEmail}
                        onValueChanged={(e) => setUserEmail(e.value)}
                        placeholder="Email"
                      />
                    </div>
                    <div className="profile-input-group-col">
                      <label>Password</label>
                      <TextBox
                        className="custom-textbox"
                        value={userPassword}
                        onValueChanged={(e) => setUserPassword(e.value)}
                        placeholder="Password"
                      />
                    </div>
                    <div className="profile-input-group-col">
                      <label>Permissions</label>
                      <TagBox
                        items={["Deposit", "Withdrawal"]}
                        value={permissions}
                        onValueChanged={(e) => {
                          setPermissions(e.value);
                          if (!e.value.includes("Deposit")) {
                            setDropPermission("false");
                          }
                        }}
                        showSelectionControls={true}
                        placeholder="Select Permissions"
                        width="100%"
                      />
                    </div>
                    {permissions.includes("Deposit") && (
                      <div className="profile-input-group-col">
                        <label>Deposit Drop Permission</label>
                        <SelectBox
                          className="custom-textbox"
                          dataSource={[
                            { id: "true", name: "True" },
                            { id: "false", name: "False" },
                          ]}
                          displayExpr="name"
                          valueExpr="id"
                          value={dropPermission}
                          onValueChanged={(e) => setDropPermission(e.value)}
                          showClearButton={false}
                        />
                      </div>
                    )}

                    <div className="profile-input-group-col">
                      <label>Traders</label>
                      <TagBox
                        items={[
                          { _id: "all", traderName: "All Traders" },
                          ...traders,
                        ]}
                        displayExpr="traderName"
                        valueExpr="_id"
                        value={selectedTraders}
                        onValueChanged={handleTraderChange}
                        showSelectionControls={true}
                        placeholder="Select Traders"
                        width="100%"
                      />
                    </div>
                    <Button
                      variant="contained"
                      sx={{
                        width: "25rem",
                        fontSize: "1.2rem",
                        fontWeight: "700",
                        height: "4rem",
                        // backgroundColor: "#D6336C",
                        // "&:hover": {
                        //   backgroundColor: "#D6336C",
                        // },
                      }}
                      color="secondary"
                      startIcon={<FaSave style={{ fontSize: "1.3rem" }} />}
                      onClick={handleCreateUser}
                    >
                      Create Panel User
                    </Button>
                  </div>
                )}
                {navValue === 1 && (
                  <UserManagementPanel
                    users={users}
                    traderList={traders}
                    fetchUsers={fetchUsers}
                  />
                )}
              </div>
            </div>
          )}

          {selectedControl === "deposit-management" && (
            <div className="selected-control-panel">
              <div className="control-panel-header">
                Create Deposit (for test)
              </div>
              <div className="control-panel-body">
                <PaymentGateway />
              </div>
            </div>
          )}

          {selectedControl === "withdrawal-management" && (
            <div className="selected-control-panel">
              <div className="control-panel-header">Withdrawal Management</div>
              <div className="control-panel-body"></div>
            </div>
          )}

          {selectedControl === "trader-management" && (
            <div className="selected-control-panel">
              <div className="control-panel-header">
                <div>Trader Management</div>
                <BottomNavigation
                  showLabels
                  value={traderNavValue}
                  onChange={(event, newValue) => {
                    setTraderNavValue(newValue);
                  }}
                  sx={{
                    marginLeft: "2rem",
                    backgroundColor: "#1c273a",
                    height: "80px",
                    fontSize: "3rem",
                    "& .MuiBottomNavigationAction-root": {
                      color: "#FFFFFF", // Varsayılan metin ve ikon rengi
                    },
                    "& .Mui-selected": {
                      color: "#00E396", // Seçili öğenin rengi
                    },
                  }}
                >
                  <BottomNavigationAction
                    label="Create Trader"
                    icon={<MdCreateNewFolder />}
                  />
                  <BottomNavigationAction
                    label="Trader List"
                    icon={<IoIosListBox />}
                  />
                  <BottomNavigationAction
                    label="Entegrasyon"
                    icon={<FaClipboard />}
                  />
                </BottomNavigation>
              </div>
              <div className="control-panel-body">
                {traderNavValue === 0 && (
                  <div className="control-panel-trader">
                    {traderCard && (
                      <div className="trader-card">
                        <div>Name: {traderCard?.traderName}</div>
                        <div>Version: {traderCard?.traderVersion}</div>
                        <div>File Name: {traderCard?.fileName}</div>
                        <div>
                          <a href={traderCard?.downloadUrl} download>
                            Download File
                          </a>
                        </div>
                      </div>
                    )}
                    <div className="profile-input-group-col">
                      <label>Trader Name</label>
                      <TextBox
                        className="custom-textbox"
                        value={traderName}
                        onValueChanged={(e) => setTraderName(e.value)}
                        placeholder="Enter Trader Name"
                      />
                    </div>

                    <div className="profile-input-group-col">
                      <label>API Version</label>
                      <SelectBox
                        className="custom-textbox"
                        dataSource={[
                          { id: "V1", name: "V1" },
                          { id: "V2", name: "V2" },
                        ]}
                        displayExpr="name"
                        valueExpr="id"
                        value={traderVersion}
                        onValueChanged={(e) => setTraderVersion(e.value)}
                        placeholder="Select Version"
                        showClearButton={false}
                      />
                    </div>

                    <Button
                      variant="contained"
                      sx={{
                        width: "25rem",
                        fontSize: "1.2rem",
                        fontWeight: "700",
                        height: "4rem",
                      }}
                      color="secondary"
                      startIcon={<FaSave style={{ fontSize: "1.3rem" }} />}
                      onClick={handleCreateTrader}
                    >
                      Create Trader
                    </Button>
                  </div>
                )}
                {traderNavValue === 1 && <TraderManagementPanel />}
                {traderNavValue === 2 && (
                  <div className="control-panel-trader">
                    {integrationSaved ? (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          padding: "3rem",
                          textAlign: "center",
                        }}
                      >
                        <div
                          style={{
                            color: "#00E396",
                            fontSize: "5rem",
                            marginBottom: "2rem",
                          }}
                        >
                          ✓
                        </div>
                        <div
                          style={{
                            fontSize: "2rem",
                            fontWeight: "bold",
                            color: "#00E396",
                          }}
                        >
                          Integration Settings Saved Successfully
                        </div>
                      </div>
                    ) : (
                      <>
                        <div className="profile-input-group-col">
                          <label>Trader</label>
                          <SelectBox
                            className="custom-textbox"
                            dataSource={traders}
                            displayExpr="traderName"
                            valueExpr="_id"
                            value={selectedTraderForIntegration}
                            onValueChanged={(e) =>
                              setSelectedTraderForIntegration(e.value)
                            }
                            placeholder="Select Trader"
                            showClearButton={true}
                          />
                        </div>

                        <div className="profile-input-group-col">
                          <label>Callback URL</label>
                          <TextBox
                            className="custom-textbox"
                            value={callbackUrl}
                            onValueChanged={(e) => setCallbackUrl(e.value)}
                            placeholder="Enter Callback URL"
                          />
                        </div>

                        <div className="profile-input-group-col">
                          <label>Redirect URL</label>
                          <TextBox
                            className="custom-textbox"
                            value={redirectUrl}
                            onValueChanged={(e) => setRedirectUrl(e.value)}
                            placeholder="Enter Redirect URL"
                          />
                        </div>

                        <Button
                          variant="contained"
                          sx={{
                            width: "25rem",
                            fontSize: "1.2rem",
                            fontWeight: "700",
                            height: "4rem",
                          }}
                          color="secondary"
                          startIcon={<FaSave style={{ fontSize: "1.3rem" }} />}
                          onClick={handleSaveIntegration}
                        >
                          Save Integration
                        </Button>
                      </>
                    )}
                  </div>
                )}
              </div>
            </div>
          )}

          {selectedControl === "trader-logs" && (
            <div className="selected-control-panel">
              <div className="control-panel-header">
                <div>Trader Logs</div>
                <BottomNavigation
                  showLabels
                  value={traderLogsNavValue}
                  onChange={(event, newValue) => {
                    setTraderLogsNavValue(newValue);
                  }}
                  sx={{
                    marginLeft: "2rem",
                    backgroundColor: "#1c273a",
                    height: "80px",
                    fontSize: "3rem",
                    "& .MuiBottomNavigationAction-root": {
                      color: "#FFFFFF", // Varsayılan metin ve ikon rengi
                    },
                    "& .Mui-selected": {
                      color: "#00E396", // Seçili öğenin rengi
                    },
                  }}
                >
                  <BottomNavigationAction
                    label="All Logs"
                    icon={<IoIosListBox />}
                  />
                  <BottomNavigationAction
                    label="Get Statistics"
                    icon={<MdOutlineAssessment />}
                  />
                </BottomNavigation>
              </div>
              <div className="control-panel-body">
                <TraderLogsPanel navValue={traderLogsNavValue} />
              </div>
            </div>
          )}

          {selectedControl === "c2c-management" && (
            <div className="selected-control-panel">
              <div className="control-panel-header">
                <div>C2C Management</div>
                <BottomNavigation
                  showLabels
                  value={c2cNavValue}
                  onChange={(event, newValue) => {
                    setC2cNavValue(newValue);
                  }}
                  sx={{
                    marginLeft: "2rem",
                    backgroundColor: "#1c273a",
                    height: "80px",
                    fontSize: "3rem",
                    "& .MuiBottomNavigationAction-root": {
                      color: "#FFFFFF",
                    },
                    "& .Mui-selected": {
                      color: "#00E396",
                    },
                  }}
                >
                  <BottomNavigationAction
                    label="Card Account"
                    icon={<FaCreditCard />}
                  />
                </BottomNavigation>
              </div>
              <div className="control-panel-body">
                {c2cNavValue === 0 && <CardAccountManagement />}
              </div>
            </div>
          )}

          {selectedControl === "trader-kassa-management" && (
            <div className="selected-control-panel">
              <div className="control-panel-header">
                <div>Trader Kassa Management</div>
              </div>
              <div className="control-panel-body">
                <TraderKassaManagementView />
              </div>
            </div>
          )}

          {selectedControl === "team-management" && (
            <div className="selected-control-panel">
              <div className="control-panel-header">
                <div>Team Management</div>
              </div>
              <div className="control-panel-body">
                <TeamManagementPanel />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminController;
